import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/aide",
        name: RouteEnum.EXTERNAL_LINK_HELP_CANDIDAT,
        beforeEnter() {
            location.href = '//apform.fr/jeunes-candidat-asv-gipsa/aide-candidature/'
        }
    },
    {
        path: "/contactez-nous",
        name: RouteEnum.EXTERNAL_LINK_CONTACT,
        beforeEnter() {
            location.href = '//apform.fr/espace-candidat/contact-candidat/'
        }
    },
    {
        path: "/facebook",
        name: RouteEnum.EXTERNAL_LINK_FACEBOOK,
        beforeEnter() {
            location.href = '//www.facebook.com/APForm'
        }
    },
    {
        path: "/instagram",
        name: RouteEnum.EXTERNAL_LINK_INSTAGRAM,
        beforeEnter() {
            location.href = '//www.instagram.com/apform_/'
        }
    },
    {
        path: "/linkedin",
        name: RouteEnum.EXTERNAL_LINK_LINKEDIN,
        beforeEnter() {
            location.href = '//www.linkedin.com/company/apform/mycompany/'
        }
    },
    {
        path: "/inscription/aide",
        name: RouteEnum.EXTERNAL_LINK_HELP_INSCRIPTION,
        beforeEnter() {
            location.href = '//apform.fr/jeunes-candidat-asv-gipsa/aide-candidature/'
        }
    },
]
